var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model.show)?_c('div',{staticClass:"support-widget"},[_c('client-only',[_c('ScrollShow',_vm._b({attrs:{"target":'#site-body'},on:{"click":_vm.onClick}},'ScrollShow',_vm.layout,false),[_c('div',{staticClass:"support-icon w-full h-full cursor-pointer",style:({
          filter: `drop-shadow(0px 7px 17.5px ${_vm.backgroundColor})`,
        })},[_c('bg-style',{staticClass:"w-full h-full cursor-pointer",attrs:{"bg":_vm.model}})],1)])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }